var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.238,
    height: 23.238,
    viewBox: "0 0 23.238 23.238",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216",
    "data-name": "Trazado 216",
    d: "M11.619,0A11.619,11.619,0,1,0,23.238,11.619,11.632,11.632,0,0,0,11.619,0ZM20.2,5.377h-.5a.494.494,0,0,0-.47.342L18.173,9,15.388,10.22,12.113,7.841V4.557L14.877,2.55A.494.494,0,0,0,15.057,2L14.9,1.513A10.657,10.657,0,0,1,20.2,5.377ZM8.339,1.512,8.182,2a.494.494,0,0,0,.18.553l2.763,2.007V7.84L7.85,10.22,5.064,9,4,5.718a.493.493,0,0,0-.47-.342h-.5A10.666,10.666,0,0,1,8.339,1.512Zm-7.35,10.1.416.3a.492.492,0,0,0,.581,0L4.724,9.925l2.785,1.224,1.264,3.887L7.089,17.041H3.652a.494.494,0,0,0-.47.342l-.153.471a10.555,10.555,0,0,1-2.04-6.236S.989,11.613.989,11.611ZM8.331,21.723l.412-.3a.493.493,0,0,0,.18-.552L7.874,17.644l1.684-2H13.68l1.682,2-1.048,3.226a.494.494,0,0,0,.181.553l.412.3a10.523,10.523,0,0,1-6.575,0Zm11.877-3.867-.153-.473a.5.5,0,0,0-.47-.341H16.149l-1.682-2,1.263-3.887,2.786-1.224,2.736,1.987a.49.49,0,0,0,.582,0l.416-.3s0,.005,0,.008A10.571,10.571,0,0,1,20.208,17.856Z",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sports.33381bd348f26a2be5705cb9e823cee6.svg";